export default "__VITE_ASSET__BOg7n9Ke__"